module.exports = __webpack_public_path__ + "img/1.fc2eb57a.jpg";